import '@progress/kendo-drawing';
import { deepExtend } from '../../utils/deep-extend.js';
import '../../math/Graph.js';
import '../../math/Shapes.js';
import '../../svg/Rotation.js';
import { Group } from '../../svg/Group.js';

class AdornerBase {
    constructor(diagram, options) {
        this.diagram = diagram;
        this.options = deepExtend({}, this.options, options);
        this.visual = new Group();
        this.diagram._adorners.push(this);
    }
    refresh() { }
}

export { AdornerBase };
